export default __webpack_public_path__ + "static/media/stract.0552bbee.png";